  import React from 'react';
  import { Button, ButtonGroup, Col, ListGroup } from 'reactstrap';
  import ListItem from './CardItem';
  import { Row, Container } from 'reactstrap';
  import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
  import Nav from './Nav';
  import PlaybackEngine from '../api/PlaybackEngine'
  import {encode, decode} from '../utils/ListEncoder'
  import { elementScrollIntoView } from "seamless-scroll-polyfill";



  //Importing SVGS
  import {ReactComponent as XBUTTON} from '../xButton.svg';
  import {ReactComponent as XBUTTONLISTE} from '../xButtonListe.svg';

  import {ReactComponent as REORDERBUTTON} from '../reorderButton.svg'
  import {ReactComponent as NOITEM} from '../noItem.svg'
  import {ReactComponent as SOUNDPLAYING} from '../playingSound.svg'
  import {ReactComponent as MUTESOUNDS} from '../muteButton.svg'
  import {ReactComponent as UNMUTESOUNDS} from '../unMuteButton.svg'
  import {ReactComponent as ARROWSCROLL} from '../arrowScroll.svg'

  class itemPicker extends React.Component {


    constructor(props) {
      super(props);
      this.accordionContent = [];

      this.state = {
        error: '',
        selectedItems: [],
        choosenItem: [],
        categories: [],
        activeCategory: 0,
        readyToPlay:false,
        playing:false,
        items: this.props.items,
        isMuted:false,
        fade:true,
        selectionURL:""
      };
      this.navContent = this.props.query;

      this.reorder = this.reorder.bind(this)
      this.updateSelectedItems = this.updateSelectedItems.bind(this)
      this.onDragEnd = this.onDragEnd.bind(this);
      this.scrollCategoriesRight = this.scrollCategoriesRight.bind(this);
      this.scrollCategoriesLeft = this.scrollCategoriesLeft.bind(this);

      this.scrollItemsUp = this.scrollItemsUp.bind(this);
      this.scrollItemsDown = this.scrollItemsDown.bind(this);



      this.unmuteSounds = this.unmuteSounds.bind(this);
      this.muteSounds = this.muteSounds.bind(this);
      this.removeSoundFromUI = this.removeSoundFromUI.bind(this);
      this.goToPlayer = this.goToPlayer.bind(this)



      this.handleMute = this.handleMute.bind(this);
      this.handleMute = this.handleMute.bind(this);
      this.addSelectionToNav = this.addSelectionToNav.bind(this);


      this.onLoading = this.onLoading.bind(this);
      this.onReady = this.onReady.bind(this);
      this.onPlaying = this.onPlaying.bind(this);
      this.onStopped = this.onStopped.bind(this);

      this.categoryClicked = this.categoryClicked.bind(this);


      this.engine = new PlaybackEngine(this.props.items, {
        onReady : this.onReady,
        onLoading : this.onLoading,
        onPlaying : this.onPlaying,
        onStopped : this.onStopped
      });

      this.pickerRef = React.createRef();


      const categories = props.items.map((item, index) => {
        //Fetch categories from json
        let itemIsInArray = this.state.categories.findIndex(x => x === item.category);
        if (itemIsInArray == -1) this.state.categories.push(item.category)
      })





    }

    componentDidMount(){
      window.dataLayer.push({
        event: 'virtualPageview',
        page: {
          path: '/articles',
          title: 'Articles'
        }
      });


      let query = this.props.query.location.search.substring(1)

      let items = decode(query);

      console.log(items);

      items.forEach((itemId, i) => {

        let indexPos = this.props.items.findIndex(x => x.id === itemId);
            if(indexPos >= 0){
              this.state.selectedItems.push(this.props.items[indexPos])
              //this.soundAdded(indexPos,this.props.json[indexPos])
        }
      });

      this.setState({ selectedItems: this.state.selectedItems },() => {
        let list = this.state.selectedItems.map((item) => {
          let indexPos = this.props.items.findIndex(x => x.id === item.id);
          return indexPos;
        })

        this.engine.setList(list);
        this.addSelectionToNav();
      });
    }

    getIDFromCategory(btnIDx) {
      console.log(this.accordionContent[btnIDx].props.id)

      this.setState({ activeCategory: btnIDx })
      //update state from selected Category
      const timer = setTimeout(() => {

        elementScrollIntoView(document.getElementById(this.accordionContent[btnIDx].props.id), { behavior: "smooth", block: "center", inline: "center" });
      // targetElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

      }, 10);


    }


    accordionToggle = key => {
      console.log(this.accordionContent[key])
    //  this.accordionContent[key].style.color = 'red'
  };

    onLoading(){
      this.setState({readyToPlay : false});
    }
    onReady(){
      this.setState({readyToPlay : true});
    }
    onPlaying(){
      this.setState({readyToPlay : false});
    }

    onStopped(){
    }



    scrollCategoriesRight(){
  let  currentPos =  document.getElementById('scrollCategories').scrollLeft
  let maxScroll = 6500
  currentPos+=600;

  currentPos > maxScroll ?  document.getElementById('scrollCategories').scroll({left:0, behavior:"smooth"  })   : document.getElementById('scrollCategories').scroll({left:currentPos+25,behavior:"smooth"})

    }

    scrollCategoriesLeft(){
      let  currentPos =  document.getElementById('scrollCategories').scrollLeft
      let maxScroll = 0
      currentPos-=600;

      currentPos < maxScroll ?  document.getElementById('scrollCategories').scroll({left:0, behavior:"smooth"  })   : document.getElementById('scrollCategories').scroll({left:currentPos+25,behavior:"smooth"})

        }

 removeSoundFromUI(e, itemId){
  if (e.defaultPrevented) {
    return;
  }

let indexPos = this.state.selectedItems.findIndex(x => {
  return x.id == itemId});
let currentTarget = this.state.selectedItems[indexPos];


this.updateSelectedItems(currentTarget,false);

}

addSelectionToNav() {
  let idList = this.state.selectedItems.map((obj) => {return obj.id})

  let b64URL = encode(idList);
  b64URL = '?' + b64URL

  this.setState({selectionURL:b64URL})
}


goToPlayer(){

  window.dataLayer.push({
    eventCategory: 'liste',
    eventAction: 'clicInterne',
    eventLabel: 'creerListe',
    event: 'genericGAEvent'
  });


this.engine.stop()
this.navContent.push('/player' + this.state.selectionURL)
}



handleMute(){
  if(this.state.isMuted){
    window.dataLayer.push({
      eventCategory: 'liste',
      eventAction: 'clicInteraction',
      eventLabel: 'ouvrirSon',
      event: 'genericGAEvent'
    });
  }else {
    window.dataLayer.push({
      eventCategory: 'liste',
      eventAction: 'clicInteraction',
      eventLabel: 'fermerSon',
      event: 'genericGAEvent'
    });
  }

  this.state.isMuted ? this.unmuteSounds() : this.muteSounds() ;
  this.setState({ isMuted: !this.state.isMuted })
}

        muteSounds(){
          this.engine.setVolume(0)
        }

        unmuteSounds(){
          this.engine.setVolume(1)
        }


  reorder = (list, startIndex, endIndex) => {
    //Reorder function ripped from the code sample lol
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;

  }

  onDragEnd(result) {
    //Called when a drag is finished
    console.log(result)

    if (!result.destination) {
      // dropped outside the list

      return;
    }

    const selectedItems = this.reorder(
      this.state.selectedItems,
      result.source.index,
      result.destination.index
    );

    this.setState({
      selectedItems
    });


    let list = selectedItems.map((item) => {
      let indexPos = this.props.items.findIndex(x => x.id === item.id);
      console.log(indexPos,item.id)

      return indexPos;
    })
    this.engine.setList(list);

    this.addSelectionToNav();

  }

    updateSelectedItems(item, status) {

      let indexPos = this.props.items.findIndex(x => x.id === item.id);
      if(indexPos >= 0){

      }

      if(status){
      //  console.log(item);
        this.engine.playFile(item.id);

        window.dataLayer.push({
            eventCategory: 'liste',
            eventAction: 'clicListe',
            eventLabel: 'ajout - ' + item.name,
            event: 'genericGAEvent'
        });

      }else{
        window.dataLayer.push({
          eventCategory: 'liste',
          eventAction: 'clicArticles',
          eventLabel: 'enlever - ' + item.name,
          event: 'genericGAEvent'
      });
      }

      status ? this.state.selectedItems.push(item) : this.state.selectedItems = this.state.selectedItems.filter(rmItem => rmItem !== item)
      //Removes items from selection if already selected or adds if it it is not already selected


      this.setState({ selectedItems: this.state.selectedItems },() => {
        let list = this.state.selectedItems.map((item) => {
          let indexPos = this.props.items.findIndex(x => x.id === item.id);
          console.log(indexPos,item.id)

          return indexPos;
        })
        console.log(list)
        this.engine.setList(list);

      });

      this.addSelectionToNav();


    }

    scrollItemsUp(){
      document.getElementById('listePicker').scroll({top:0, behavior:"smooth"  })
    }


    scrollItemsDown(){
      if(   document.getElementById('scrollDrop')){
        document.getElementById('scrollDrop').scroll({top:10000, behavior:"smooth"  })

      }
    }

    categoryClicked(index, item){
      let name = item;

      window.dataLayer.push({
        eventCategory: 'liste',
        eventAction: 'clicListe',
        eventLabel: 'afficher - ' + name,
        event: 'genericGAEvent'
      });

      this.getIDFromCategory(index);
    }


    render() {

      const btnCategories = this.state.categories.map((item, index) => {
        //Generates btns from the categories
        let isDisabled = false;

        if (this.state.activeCategory == index){
          isDisabled = true;

        }
          //Disables btn if activee

          let btnContent = <Button ref={ref => (this.accordionContent[index] = ref)} className="categoryBtn" id={'btn' + String(index)} key={index} disabled={isDisabled} onClick={() => this.categoryClicked(index, item)}>{item}</Button>
          return btnContent
      })



      const listItems = this.state.items.map((item, index) => {
      //Generates the list of selectable Items
     let isSelected = this.state.selectedItems.includes(item)

        if (item.category == this.state.categories[this.state.activeCategory]) {

          //Only returns items from active category
          return <ListItem
            key={index}
           index={index}
            item={item}
            selected={isSelected}
            itemSelector={this.updateSelectedItems}
            scrollDrop={this.scrollItemsDown}
          />
        }

      })

      let btnOff =  this.state.selectedItems.length <= 0 ? "btnVoir disableBtnVoir" :  "btnVoir"
      let mutedImg =   this.state.isMuted ? <MUTESOUNDS/> : <UNMUTESOUNDS/>;


      let btnViewList =       this.state.fade ? <Button  className={btnOff}  onClick={() =>this.setState({fade:!this.state.fade}) } style={{display:"none"}}>Voir liste ({this.state.selectedItems.length})</Button> : <Button onClick={this.goToPlayer}  className="btnVoir" style={{display:"none"
      }}> Écouter ma liste chantée</Button>

      return (


        <React.Fragment>
          <Container style={{
            maxWidth:"90%",
            overflow:""
                }} >

            <Row>

              <Col lg="100" xl="8" id="navRow">

              <Nav handler={this.props.handler}/>

              <div className="gradientSide" style={{
                  float:'right',
                  width:"60px",
                  height:"200px",
                backgroundImage: "linear-gradient(90deg, rgba(0,97,174,0) 2%, rgba(0,97,174,1) 30%)",
                position:"absolute",
                left:"61%",
                  zIndex:"1"

                }}>


                </div>
                <div className="arrows">

              <div style={{
              position:"absolute",
              marginLeft:"225px",
              marginTop:"0.5gpx",
              cursor:"pointer",

              zIndex:1000000


              }} onClick={this.scrollCategoriesRight}>
                  <ARROWSCROLL/>

              </div>


              <div style={{
              position:"absolute",
              marginLeft:"175px",
              marginTop:"0px",
              transform:"rotate(180deg)",
              cursor:"pointer",
              zIndex:1000000


              }} onClick={this.scrollCategoriesLeft}>
                  <ARROWSCROLL/>

              </div>
                </div>
                <Row id="articleRow" style={{justifyContent:"space-between"}}>
                <Col md="">
              <h1 style={{
                  fontWeight:"bold",
                  fontSize:'2em',
                  textAlign:'left'
                }}>ARTICLES</h1>
              </Col>
              <Col md="5" style={{
                display:"flex",
                justifyContent:"flex-end",
                zIndex:"10"
              }}>
                <div onClick={this.handleMute}>
                {mutedImg}

                </div>
              </Col>

                </Row>

                <ButtonGroup id="scrollCategories" onClick={this.scrollItemsUp} style={{
                  display:"block ruby",
                  zIndex:'-.3',
                 scrollbarWidth:"none",
                  overflowX:"scroll",
                  overflowY:"hidden",
                  maxWidth:"inherit",
                  marginBottom:"-20px",
                  fontSize:"13px"
                }}>
                  {btnCategories}
                  <Button style={{
                    color:"rgba(0,0,0,0)",
                    background:"0",
                    border:"none"
                  }} disabled>wwopjdjklfjnlskfjnsidfsnhioe</Button>
                </ButtonGroup>

                <Row id="listePicker" md='4' xl='4' xs='2' s='3' ref={this.pickerRef} style={{
                  marginRight:"10px",
                 maxHeight:'64vh',
                 overflowX:"hidden",
                 overflowY:"scroll"

                }}>
                  {listItems}
                </Row>



              </Col>
                {btnViewList}
              <Col id="menuListe" className={this.state.fade? "out" : "in"} md="100" lg="100" xl="4" sx="100" style={{
                backgroundSize:"100% 100%",
              //  backgroundImage:"url('/assets/branding/cadre_liste.png')",
                height:"fit-content"
              }}>



                <div id="" className="flexParent" style={{
                marginBottom:"-122px"
                }}>

                <div className="gui" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(-90deg)',
marginTop:"-20px",
marginLeft:"-30px",
backgroundSize:"cover"
}}></div>






<div className="gui" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(-0deg)',
marginTop:"-20px",
marginRight:"-30px",

backgroundSize:"cover",
float:'right'
}}></div>




                </div>
<XBUTTONLISTE  onClick={() =>this.setState({fade:!this.state.fade}) }/>





              <div  className="divName" style={{height:"120px"}}>
              <h1 className="listName" style={{
                  fontWeight:"bold",
                  textAlign:'center',
                }}>MA LISTE</h1>

 {this.state.selectedItems.length > 0 &&
                <h4 className="noSelect" style={{fontWeight:'bold',cursor:"pointer"}} disabled={!this.state.readyToPlay} onClick={()=>{this.engine.play(true)}} >Aperçu <span></span>
    <SOUNDPLAYING/></h4>}
              </div>

              <Col>


              <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                 {(provided, snapshot) => (
                   <div id="scrollDrop" style={{
                   minHeight:"60vh",
                     maxHeight:"60vh",
                     overflow:"auto",

                   }}


                     {...provided.droppableProps}
                     ref={provided.innerRef}

                    >
                      {this.state.selectedItems.length == 0 &&

<div>
<img src="/assets/branding/listeVide.png" width="100%"  alt="Liste vide!" style={{
  marginTop:"10vh",
  maxWidth:"500px",
}}/>

<h3 style={{textAlign:"center",fontWeight:"light",maxWidth:"500px",margin:"auto",paddingTop:"50px",fontSize:"1em"}}>Sélectionnez des articles pour commencer votre liste.</h3>
</div>
}
                {this.state.selectedItems.map((item, index) => (
                  <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                    {(provided, snapshot) => (
                      <div className="selectable"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}

                      >
                        <div className="spacerL">

                        </div>
                        <div className={item.id} onClick={(e) => this.removeSoundFromUI(e, item.id)}>
                          <XBUTTON />
                        </div>
                       <div className="textProduit" style={{
                         width:"190px",
                         marginLeft:"20px"
                       }}>
                          {item.name}
                          </div>
                          <REORDERBUTTON/>
                          <div className="spacerR"></div>


                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>



        </DragDropContext>
              </Col>








              <div id="marginMaliste" className="flexParent" style={{
                marginBottom:"-137px",
                zIndex:"10000"
                }}>

                <div className="gui" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(180deg)',
marginLeft:"-30px",
backgroundSize:"cover"
}}></div>


<div className="gui" style={{

backgroundImage:"url('/assets/branding/guiCorner.png')",
transform:'rotate(90deg)',
marginRight:"-30px",

backgroundSize:"cover",
float:'right'
}}></div>





                </div>




 {this.state.selectedItems.length > 0 &&
                            <Button  outline color="none" className="createList" id="createListDesktop" onClick={this.goToPlayer} disabled={!this.state.readyToPlay} ><h4 style={{fontWeight:"bold",marginTop:"3px"}}>Créer ma liste chantée</h4></Button>

     }


              </Col>
            </Row>

          </Container>
        </React.Fragment>
      )
    }
  }

  /*                      <div style={{
height:"-webkit-fill-available",
backgroundColor:"#0475c4",
width:"10px",
float:"left"
}}>

</div>
         */

  export default itemPicker;
